import { PropsWithChildren } from 'react';

// Removes the container padding to allow for the use of full-width components like Page Header
export const GenericMasonryPageWrapper = ({
  children,
}: PropsWithChildren<{}>) => <>{children}</>;
